<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <div slot="header">
          <h1>Gruppen - Zuweisung</h1>
          <div class="card-header-actions"></div>
        </div>
        <b-row>
          <b-col lg="8">
            <b-form
              v-on:submit.prevent="onSubmit"
              v-on:reset.prevent="onReset"
              novalidate
            >
              <b-form-group id="publicitygroupAssignmentGroup1">
                <multiselect
                  id="groupAssignmentSelector"
                  v-model="publicitygroup"
                  :options="getPublicitygroupNames"
                  :multiple="false"
                  @select="pokeFacilitySelector"
                  placeholder="Wählen Sie die gewünschte Gruppe aus"
                ></multiselect>
              </b-form-group>

              <facility-selector
                @change="changed = true"
                ref="facilitySelector"
              ></facility-selector>

              <br />
              <hr />
              <!-- === Buttons === -->
              <div style="text-align: center">
                <b-button type="submit" variant="primary" :disabled="licenseExpired">
                  Änderungen übernehmen
                </b-button>
                <b-button
                  class="ml-1"
                  type="button"
                  @click="onReset"
                  variant="danger"
                  >Änderungen verwerfen</b-button
                >
              </div>
            </b-form>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
import FacilitySelector from "../../FacilitySelector";

import { mapGetters, mapActions } from "vuex";

// VUE izitoast
import VueIziToast from "vue-izitoast";
import "izitoast/dist/css/iziToast.min.css";
Vue.use(VueIziToast);

import NotificationMixin from "../../../mixins/notificationmixin";

export default {
  mixins: [NotificationMixin],
  data() {
    return {
      publicitygroup: "",
      changed: false,
    };
  },
  components: {
    Multiselect,
    FacilitySelector,
  },
  mounted: function () {
    if (!this.getAssignedFacilityStatus) {
      this.loadAssignedFacilities();
    }

    if (!this.getPublicitygroupStatus) {
      this.loadPublicitygroups();
    }

    // if a user comes from the grouptable "Details/Edit"-Menu, prefill form
    if (this.$route.params.groupname) {
      this.publicitygroup = this.$route.params.groupname;
      this.pokeFacilitySelector(this.publicitygroup);
    }
  },
  computed: {
    ...mapGetters([
      "getPublicitygroupNames",
      "getAssignedFacilityStatus",
      "getPublicitygroupStatus",
      "getPublicitygroupFacilities",
      "getPublicitygroupFacilityGroupIds",
      "getPublicitygroupIdByName",
      "getPublicitygroupFacilityAssignmentObjectsByIds",
      "getAssignedFacilities",
      "licenseExpired",
    ]),
  },
  methods: {
    ...mapActions([
      "loadAssignedFacilities",
      "loadPublicitygroups",
      "updatePublicitygroup",
    ]),
    pokeFacilitySelector(payload) {
      // note: had to pass the return of getter to child component as when calling the getter from child,
      // it did return a function instead of data ?!
      this.$refs.facilitySelector.fetchFacilities(
        this.getPublicitygroupFacilities(payload)
      );
    },

    async onSubmit() {
      if (!this.publicitygroup) {
        this.report(`Wählen Sie eine Gruppe aus.`, this.$toast);
        return;
      }

      if (!this.changed) {
        this.report(`Es wurden keine Änderungen vorgenommen.`, this.$toast);
        return;
      }

      // update backend
      let publicitygroupid = this.getPublicitygroupIdByName(
        this.publicitygroup
      );

      // get newly assigned facility ids from facility selector child component
      let publicitygroupfacilityids = this.$refs.facilitySelector.memberOf.map(
        (facility) => facility.facilityid
      );

      // for server payload, map facility ids to objects with facility id and business id props
      let publicitygroupfacilities = this.getPublicitygroupFacilityAssignmentObjectsByIds(
        publicitygroupfacilityids
      );

      let err = await this.updatePublicitygroup({
        publicitygroupid,
        publicitygroupfacilities,
      });

      this.notify(
        err,
        `Die Gruppenzuweisung wurde erfolgreich geändert.`,
        `Die Gruppenzuweisung konnte nicht geändert werden.`,
        this.$toast
      );

      if (!err) {
        // update facilities global state
        let assignedFacilities = this.getAssignedFacilities;

        // go over all assinged facilities (since only assigned facilities can be assigned to publicitygroups)
        for (let fac of assignedFacilities) {
          // if the publicitygroup array of a facility object contains the selected group ...
          if (
            fac.Publicitygroups.find(
              (group) => group.Groupname === this.publicitygroup
            )
          ) {
            // ... remove the group
            fac.Publicitygroups.splice(
              fac.Publicitygroups.findIndex(
                (group) => group.Groupname === this.publicitygroup
              ),
              1
            );
          }
        }

        // go over all assinged facilities a second time add aforementioned publicitygroup to facilities in question
        for (let fac of assignedFacilities) {
          // if the facility has an ID that is element of "publicitygroupfacilityids" ...
          if (publicitygroupfacilityids.includes(fac.idFacility)) {
            // ... add the group
            fac.Publicitygroups.push({
              Groupname: this.publicitygroup,
              idPublicitygroup: publicitygroupid,
            });
          }
        }
        this.changed = false;
      }
    },
    onReset() {
      this.$refs.facilitySelector.fetchFacilities(
        this.getPublicitygroupFacilities(this.publicitygroup)
      );
      this.changed = false;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>